/*
 File: interstitial-ad.js
 Author: D McCleod
 Created: 4/07/2017
 Modified:
 Description: interstitial ad for mobile
 public event listeners: 'interad:Removed', 'interad:inserted'
 */

import { overlayMng } from './overlays.js';
import { holdVirtualTracking } from './slider-events';
import { currentHash } from './hash-manager';
import { virtualTracking } from './slide-tracking';
import * as config from './config';


const interAd = {
    adPos: 1522,
    adCounter: 0,
    adClass: 'inter1522',
    adSlide: null,
    body: null,
    bodyClass: 'has-interstitial',
    container: $('#interstitial-slider'),
    containerID: 'interstitial-slider',
    currentIndex: null,
    frequency: 4,
    frequency2nd: 5,
    initialized: false,
    initialView: false,
    interstitialId: 'interstitial-',
    interstitialCount: 0,
    layersContainer: $('.layers-container'),
    overlayID: 'ss-interstitial',
    mainSlider: config.slideContainer,
    swipeDirection: '',

    init: function() {
        this.initialized = true;
        this.body = $('body');

        let that = this;
        // add event handlers
        $(window)
            .on('interad:countchange', this.on_countChange.bind(this))
            .on('interad:removead', this.removeAd.bind(this));

        this.mainSlider
            .on('swipeleft', this.on_swipe.bind(this))
            .on('swiperight', this.on_swipe.bind(this));

        // set global listener for windows that may not have jQuery, trackParam will ony be defined when called by collapse-ad.js
        window.slideShow.triggers.removead = function(trackParam){
            interAd.removeAd.call(interAd, trackParam);
        };

        // USE WITH LAYER
        this.interstitialId += this.adCounter;
        this.insertHTML(this.layersContainer);
        this.adSlide = $('.'+this.adClass);
        this.container = $('#' + this.containerID);
        // set events and handlers
        this.addEvents();
        this.layersContainer.on('click', '.inter-back', this.goBack.bind(this));
        this.layersContainer.on('click', '.inter-skip', this.goForward.bind(this));
    },

    // triggered from slick.js modification in Slick.prototype.slideHandler
    on_countChange: function(event, data){
        if(this.initialized){

            if(window.slideShow.displayInterstitial) {
                window.slideShow.displayInterstitial = false;
            } else if(currentHash !== data.slideIndex + 1){
                slideShow.interstitialCount ++;

                if(slideShow.interstitialCount === this.frequency) {
                    // set global var, evaluated by virtualpage track call
                    window.slideShow.displayInterstitial = true;
                    this.currentIndex = data.slideIndex;
                    slideShow.interstitialCount = 0;
                    this.body.addClass(this.bodyClass);
                    this.insertSlider();

                    if(!this.initialView) {
                        this.initialView = true;
                        this.frequency = this.frequency2nd;
                    }
                }
            }
        }
    },

    on_swipe: function(event, data){
        this.swipeDirection = data.direction;
    },

    getCurrentIndex: function(){
        this.currentIndex = $('.slick-current').data('slick-index');
        return this.currentIndex;
    },

    setAdId: function(){
        return this.interstitialId + this.incrementAdId();
    },

    getAdPos: function(){
        return this.adPos;
    },

    incrementAdId: function(){
        this.adCounter ++;
        return this.adCounter;
    },

    goBack: function(event){
        this.removeAd();
    },

    goForward: function(event){
        this.removeAd();
    },

    insertSlider: function(){
        let that = this;
        overlayMng.open(this.overlayID);
        // init slick, this creates a new slideshow in the layer, actual ad insertion will happen on the 'init' call below to ensure the UI has updated
        this.container.slick(config.adConfig);
    },

    triggerEvent: function(obj){
        let _event = obj.listener;
        let _data = obj.data;
        //set global listener for external scripts
        $(window).trigger(_event, _data);

        return _event;
    },

    removeAd: function(trkParam){
        // test body class for when function is called outside of slideshow.js, ex: from prof ads
        if(! this.body.hasClass(this.bodyClass) ) return;

        window.slideShow.displayInterstitial = false;
        this.adSlide.removeClass('AdUnit').empty().attr('id', '');
        this.container.slick('unslick');
        this.body.removeClass(this.bodyClass);
        overlayMng.close();
        // call virtual track when ad is closed, but not if an empty ad. trkParam will only be defined when an empty ad closes
        if(!trkParam) holdVirtualTracking.track.bind(holdVirtualTracking)();
    },

    addEvents: function(){
        let that = this;
        this.container
            .on('init', function(event, slick) {
                let id = that.setAdId();
                that.adSlide.attr('id', id);
                // call ad API with delay
                setTimeout(function(){
                    that.insertInterstitialSlide.call(that, id);
                    that.insertSpacerImage(that.adSlide);
                    // call tracking for ad
                    virtualTracking({type: 'ad', data: 'ss_intad'});
                }, 500);
                // uncomment below <div> to display an FPO ad locally
                //$('#'+id).append('<div style="width: 300px; height: 250px; background: lightblue;">Ad Stuff</div>');

                that.triggerEvent({
                    listener: 'interad:inserted',
                    data: that.getCurrentIndex()
                });
            })
            .on('swipe', function(event, slick, direction){
                that.removeAd();
            })
            .on('destroy', function(event, slick){
                that.triggerEvent({
                    listener: 'interad:Removed',
                    data: that.getCurrentIndex()
                });
            });

        $(document).on('dfpRenderComp', function () {
            //if(window.slideShow.displayInterstitial) console.log(' (( AdUnit inserted )) ');
        });
    },

    insertInterstitialSlide: function(divId) {
        $("#" + divId).addClass("AdUnit");
        webmd.ads2.sizes[`${this.adPos}`] = [
            [300, 250]
        ];
        webmd.ads2.defineAd({
            id: divId,
            pos: this.adPos,
            collapseAfter: true
        });
    },
    // and image spacer is needed to add height to the slide, below the ad, so swipe event can be triggered
    insertSpacerImage: function(ele) {
      let img = document.createElement('img');
          img.setAttribute('src', '//img.medscapestatic.com/pi/global/1x1.png');
          img.classList.add('inter-spacer-img');
      ele.append(img);

      return img;
    },

    insertHTML: function(container){
        // temporarily add to dom, until template is updated
        // add in the div id [this.interstitialId] to the string template
        let html = `
            <div class="modal-layer modal-layer__inter" id="ss-interstitial">
                <div class="inter-logo fadein"><img src="//img.medscapestatic.com/pi/logos/mscp-logo.png" alt="Medscape Logo"></div>
                <div class="inter-navigation crs-pagination crs-pagination--bottom fadein">
                    <a role="button" class="crs_nav_arrow crs_nav--button bg-blue slick-arrow inter-back"></a>
                    <a role="button" class="crs_nav_arrow crs_nav--button bg-blue slick-arrow inter-skip">${slideShowVars.skipadtext}</a>
                </div>
                <div class="inter-container" id="${this.containerID}">
                    <div class="inter-slide empty"></div>
                    <div class="inter-slide fadein ${this.adClass}" id=""></div>
                    <div class="inter-slide empty"></div>
                </div>
            </div>
        `;
        container.append(html);
        return container;
    }

};


export { interAd };
